// @ts-nocheck
import { z } from "zod";
export const contentPartSchema = z.object({ "text": z.string() });
